// extracted by mini-css-extract-plugin
export default {"notice":"dJHEHqa7","link":"XrbeSuc4"};